var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSqure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_306_3233",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0004 14.9995V20H7.99981V14.9995H13.0004ZM5.50062 14.9995V20H0.5V14.9995H5.50062ZM20.5002 14.9995V20H15.4996V14.9995H20.5002ZM5.50062 7.49972V12.5003H0.5V7.49972H5.50062ZM13.0004 7.49972V12.5003H7.99981V7.49972H13.0004ZM20.5002 7.49972V12.5003H15.4996V7.49972H20.5002ZM5.50062 0V5.00047H0.5V0H5.50062ZM20.5002 0V5.00047H15.4996V0H20.5002ZM13.0004 0V5.00047H7.99981V0H13.0004Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_306_3233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H20.5002V20H0.5V0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqure);
export default __webpack_public_path__ + "static/media/squre.9e4de67ed23ebba094ebf95c458c1288.svg";
export { ForwardRef as ReactComponent };